/**
 * Return the index of the element at or before the given time
 */
function findElement(array, time) {
  var beginning = 0;
  var len = array.length;
  var end = len;

  if (len > 0 && array[len - 1].time <= time) {
    return len - 1;
  }

  while (beginning < end) {
    // calculate the midpoint for roughly equal partition
    var midPoint = Math.floor(beginning + (end - beginning) / 2);
    var event = array[midPoint];
    var nextEvent = array[midPoint + 1];

    if (event.time === time) {
      //choose the last one that has the same time
      for (var i = midPoint; i < array.length; i++) {
        var testEvent = array[i];

        if (testEvent.time === time) {
          midPoint = i;
        }
      }

      return midPoint;
    } else if (event.time < time && nextEvent.time > time) {
      return midPoint;
    } else if (event.time > time) {
      //search lower
      end = midPoint;
    } else if (event.time < time) {
      //search upper
      beginning = midPoint + 1;
    }
  }

  return -1;
}
/**
 * Does a binary search to insert the note
 * in the correct spot in the array
 * @param  {Array} array
 * @param  {Object} event
 * @param  {Number=} offset
 */


function BinaryInsert(array, event) {
  if (array.length) {
    var index = findElement(array, event.time);
    array.splice(index + 1, 0, event);
  } else {
    array.push(event);
  }
}

export { BinaryInsert };